// import { defaultMaxListeners } from "events";
// import Header from "./Header";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import './LogoutHeader.css';


const LogoutHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    setTimeout(() => navigate("/login"), 0);
  };

  return (
    <div className="layout-wrapper">
      {isLoggedIn && (
        <header className="logout-header">
          <h1 className="logout-header-title" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
            <i className="bi bi-hospital me-3"></i>
            Doctor Portal
          </h1>
          <button onClick={handleLogout} className="logout-header-btn">
            Logout
          </button>
        </header>
      )}
      <main className="logout-header-main">{children}</main>
      {isLoggedIn && <Footer />}
    </div>
  ); 

};

export default LogoutHeader;
